//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql

import com.apollographql.apollo.annotations.ApolloAdaptableWith
import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CompiledField
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.Mutation
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.adapter.CompleteInspectionMutation_ResponseAdapter
import com.wintermar.inspection.graphql.adapter.CompleteInspectionMutation_VariablesAdapter
import com.wintermar.inspection.graphql.selections.CompleteInspectionMutationSelections
import com.wintermar.inspection.graphql.type.CompleteInspectionCommandInput
import com.wintermar.inspection.graphql.type.InspectionStatus
import kotlin.Any
import kotlin.Boolean
import kotlin.String
import com.wintermar.inspection.graphql.type.Mutation as CompiledMutation

public data class CompleteInspectionMutation(
  public val completeInspectionCommandInput: CompleteInspectionCommandInput,
) : Mutation<CompleteInspectionMutation.Data> {
  override fun id(): String = OPERATION_ID

  override fun document(): String = OPERATION_DOCUMENT

  override fun name(): String = OPERATION_NAME

  override fun serializeVariables(
    writer: JsonWriter,
    customScalarAdapters: CustomScalarAdapters,
    withDefaultValues: Boolean,
  ) {
    CompleteInspectionMutation_VariablesAdapter.serializeVariables(writer, this, customScalarAdapters, withDefaultValues)
  }

  override fun adapter(): Adapter<Data> = CompleteInspectionMutation_ResponseAdapter.Data.obj()

  override fun rootField(): CompiledField = CompiledField.Builder(
    name = "data",
    type = CompiledMutation.type
  )
  .selections(selections = CompleteInspectionMutationSelections.__root)
  .build()

  @ApolloAdaptableWith(CompleteInspectionMutation_ResponseAdapter.Data::class)
  public data class Data(
    public val completeInspection: CompleteInspection,
  ) : Mutation.Data

  public data class CompleteInspection(
    public val id: Any,
    public val status: InspectionStatus,
    public val lastUpdatedAt: Any?,
  )

  public companion object {
    public const val OPERATION_ID: String =
        "39e485ac3735fcaa14864daad705c13ed5868586d78c875f6057b0ca4ae6857c"

    /**
     * The minimized GraphQL document being sent to the server to save a few bytes.
     * The un-minimized version is:
     *
     * ```
     * mutation completeInspection($completeInspectionCommandInput: CompleteInspectionCommandInput!) {
     *   completeInspection(command: $completeInspectionCommandInput) {
     *     id
     *     status
     *     lastUpdatedAt
     *   }
     * }
     * ```
     */
    public val OPERATION_DOCUMENT: String
      get() = "mutation completeInspection(${'$'}completeInspectionCommandInput: CompleteInspectionCommandInput!) { completeInspection(command: ${'$'}completeInspectionCommandInput) { id status lastUpdatedAt } }"

    public const val OPERATION_NAME: String = "completeInspection"
  }
}
